"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const config_1 = require("config");
const merchant_portal_components_1 = require("merchant-portal-components");
const utils_1 = require("utils");
const NewDealBanner_1 = __importDefault(require("../../components/NewDealBanner"));
const utils_2 = require("../../new_deal/views/DocUpload/utils");
const reducer_1 = require("../../reducer");
const checkLocations_1 = require("./utils/checkLocations");
const AppBanners = ({ allLocations, currentLocation, getProposedEnrollmentDataChanges, }) => {
    // Sessions
    const hasDismissedNewDeal = sessionStorage.getItem('displayNewDeal');
    // Hooks
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    // State
    const [showSignerBanner, setShowSignerBanner] = (0, react_1.useState)(false);
    const [showNonSignerBanner, setShowNonSignerBanner] = (0, react_1.useState)(false);
    const [showNoAuthSignerBanner, setShowNoAuthSignerBanner] = (0, react_1.useState)(false);
    const [showUploadDocsBanner, setShowUploadDocsBanner] = (0, react_1.useState)(false);
    const rerouteToNewDeal = () => {
        history.push({
            pathname: (0, config_1.makeMerchantPortalPath)(config_1.PATH.NEW_DEAL),
            state: {
                from: '/merchant-portal',
                data: allLocations,
            },
        });
    };
    const gotoDocMgmt = () => {
        history.push({
            pathname: '/merchant' + config_1.PATH.DOCUMENT_MANAGEMENT,
        });
    };
    (0, react_1.useEffect)(() => {
        checkAndSetIfDocUploadBannerShouldShow();
    }, [currentLocation]);
    const checkAndSetIfDocUploadBannerShouldShow = (0, react_1.useCallback)(async () => {
        if (currentLocation &&
            currentLocation.metadata &&
            currentLocation.isCurrentLocationManagerSigner) {
            const curData = [currentLocation];
            const proposedChangeMap = await (0, utils_2.setupChangesMap)(curData, getProposedEnrollmentDataChanges);
            const dataStruct = (0, utils_2.createDataStructure)(proposedChangeMap, curData);
            if (dataStruct && !!dataStruct.length) {
                const currentLocationProposedChanges = proposedChangeMap.get(currentLocation.adsStoreNumber);
                const needsFileUploadRes = (0, utils_2.needsFileUpload)(dataStruct[0].bankingChanged, dataStruct[0].entityChanged, currentLocationProposedChanges?.files);
                setShowUploadDocsBanner(needsFileUploadRes?.needsBankingFileUpload ||
                    needsFileUploadRes?.needsEntityFileUpload);
            }
            else {
                setShowUploadDocsBanner(false);
            }
        }
        else {
            setShowUploadDocsBanner(false);
        }
    }, [currentLocation]);
    (0, react_1.useEffect)(() => {
        let needToRedirect = false;
        // Recheck
        const { signerBanner, noSignersBanner, nonSignerBanner } = (0, checkLocations_1.checkLocations)(allLocations, currentLocation);
        if (signerBanner) {
            // Signer
            needToRedirect = true;
            // Signer Redirect
            if (allLocations.length &&
                needToRedirect &&
                hasDismissedNewDeal !== 'false' &&
                location?.state?.from !== '/new-deal') {
                rerouteToNewDeal();
            }
        }
        // No Signer
        setShowSignerBanner(signerBanner);
        setShowNoAuthSignerBanner(noSignersBanner);
        setShowNonSignerBanner(nonSignerBanner);
    }, [allLocations, currentLocation]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-center flex-dir-col", children: [(0, jsx_runtime_1.jsx)(NewDealBanner_1.default, { showSignerBanner: showSignerBanner, showNonSignerBanner: showNonSignerBanner, showNoAuthSignerBanner: showNoAuthSignerBanner, rerouteToNewDeal: rerouteToNewDeal, currentLocation: currentLocation }), showUploadDocsBanner && ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.AnnouncementBanner, { fullWidth: false, callback: gotoDocMgmt, btnText: `UPLOAD DOCUMENTS`, bodyText: `To validate your updates, Alphaeon Credit requires documentation proof. Please upload the necessary documents. ` }))] }));
};
function mapStateToProps(state) {
    return {
        currentLocation: reducer_1.selectors.currentLocation(state),
        currentLocationIndex: reducer_1.selectors.currentLocationIndex(state),
        allLocations: reducer_1.selectors.allLocations(state),
    };
}
const mapDispatchToProps = {};
const mapApiAuthToProps = {
    getProposedEnrollmentDataChanges: apiActions.getProposedEnrollmentDataChanges,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(AppBanners);
